export default {
  getLocation(locationID, target) {
    const obj = {
      actionType: appConstants.ActionTypes.GET_LOCATION,
      postData: { target },
    };
    obj.postData[Utils.getEndpointParam('LOCATION_ID_PARAM')] = locationID;
    MakeShiftEmployeeDispatcher.dispatch(obj);
  },
};
